import React from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer" style={{backgroundColor:"#343333"}}>
        <Container fluid={true}>
          <Row>
            <Col sm={12} className="text-center"> © { new Date().getFullYear()} Clued.in Closet.</Col>
            {/* <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
              Developed by CAP Digisoft Solutions
              </div>
            </Col> */}
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
